var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.errors).length)?_c('div',{staticClass:"alert alert-danger py-2",attrs:{"role":"alert"}},[_vm._v("Revise os campos destacados para prosseguir ("+_vm._s(Object.keys(_vm.errors).length)+" pendência(s)).")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }